import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { CompanyCodeService } from '../proxy/controlling/controllers/company-code.service';

import { SapOldProfitCenter } from '../sap-old-profit-center/sap-old-profit-center';
FieldBuilder.setNamespace('Controlling');

export const PROFITCENTER_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.ProfitCenter.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('sapCode', 'Entity.ProfitCenter.SapCode')
    .required()
    .minLength(1)
    .maxLength(20)
    .build(),
  FieldBuilder.foreignKey('companyCodeId', 'Entity.CompanyCode', CompanyCodeService)
    .required()
    .displayFromNested('companyCode.name')
    .sortBy('companyCode.name')
    .build(),
];

export const PROFITCENTER_CONFIG = {
  entityName: 'ProfitCenter',
  localizationKey: 'Controlling::Entity.ProfitCenter',
  fields: PROFITCENTER_FIELDS,
  permission: 'ControllingSap.ProfitCenters',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.SAP + MENU_NAME_SUFFIX,
  children: [
    {
      entityName: 'SapOldProfitCenter',
      foreignKeyField: 'profitCenterId',
      localizationKey: 'Controlling::Entity.SapOldProfitCenter',
      component: SapOldProfitCenter,
    },
  ],
};
